var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContractDark = function SvgContractDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-path-1",
    d: "M0 0h64v64H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract-dark-(DEV)-Assets",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "contract-dark-icon-dark-contract"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "contract-dark-mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contract-dark-path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contract-dark-icon-contract",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#contract-dark-mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-39",
    stroke: "#30B7FD",
    d: "M29.826 10.87h-4.26c-1.177 0-2.131.973-2.131 2.173s.954 2.174 2.13 2.174h2.13c1.177 0 2.131.974 2.131 2.174s-.954 2.174-2.13 2.174h-4.261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-41",
    stroke: "#30B7FD",
    d: "M26.63 8.696v2.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-43",
    stroke: "#30B7FD",
    d: "M26.63 19.565v2.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-45",
    stroke: "#00293C",
    d: "M34.087 15.217h8.522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-47",
    stroke: "#00293C",
    d: "M34.087 21.739h8.522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-49",
    stroke: "#00293C",
    d: "M34.087 8.696h8.522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-51",
    stroke: "#00293C",
    d: "M23.435 28.261h19.174"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-53",
    stroke: "#00293C",
    d: "M34.087 34.783h8.522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-55",
    stroke: "#00293C",
    d: "M21.304 50c-2.353 0-4.26-1.947-4.26-4.348V4.348C17.043 1.947 15.135 0 12.782 0h31.956C47.092 0 49 1.947 49 4.348V39.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-57",
    stroke: "#00293C",
    d: "M12.783 34.783H4.26c2.353 0 4.26-1.947 4.26-4.348V4.348C8.522 1.947 10.43 0 12.784 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-59",
    stroke: "#00293C",
    d: "M4.26 34.783c-2.352 0-4.26-1.947-4.26-4.348V13.043h4.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contract-dark-Stroke-61",
    stroke: "#00293C",
    d: "M53.26 45.652C53.26 48.053 51.354 50 49 50H21.304c2.353 0 4.261-1.947 4.261-4.348v-2.174h27.696z"
  })))))));
};
export default SvgContractDark;